import { render } from "./UploadImageBrand.vue?vue&type=template&id=546a7db4"
import script from "./UploadImageBrand.vue?vue&type=script&lang=js"
export * from "./UploadImageBrand.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__